import { createFileRoute } from '@tanstack/react-router';
import { ConnectFlow } from 'src/apps/device/components';

export const Route = createFileRoute('/_auth/_layout/device/apps/connect')({
  component: () => <ConnectFlow />,
});
